import { MediaContentDTO } from "@touche-lts/panel-ui/dist";

export enum SKUTableActions {
    ACTIONS = 'Actions',
    PRICE = 'Change price',
    QUANTITY = 'Change quantity in stock',
    ARCHIVE = 'Archive'
}

export enum SKUTableSortedBy {
    ALL = 'All',
    ACTIVE = 'Active',
    ARCHIVED = 'Archived'
}

export interface ProductSKUAttributes {
    createdDate?: number;
    groupId?: number;
    id?: number;
    name: string
    status: string;
    value: string;
}
export interface ProductSKUsDTO {
    curr: string;
    price: number | string;
    sku: string;
    stock: number | string;
    images?: MediaContentDTO[];
    attributes?: ProductSKUAttributes[]
    createdDate?: number;
    id?: number;
    status?: string;
    isChecked?: boolean;
    sold?: number;
    revenie?: number;
    variantId?: number | string;
}